module.exports = __webpack_public_path__ + "fonts/f1520e7775125166407d134d85c99af7.svg";